// 按页面划分
export default {
    // 公共页面
    common: {
        title:"Data Mall",
        pull_refresh: 'Trek naar beneden om op te frissen',
        release_refresh: 'Laat los om te vernieuwen',
        refresh_loading: 'Laden ...',
        footer_text: 'Diensten geleverd door Ucloudlink (NASDAQ: UCL)'
      },
      home: {
        input_placeholder: 'Zoek land/regio',
        my_flow: 'Mijn gegevens',
        charge_code: 'Voucher code',
        coupons:'Coupons',
        local_package: 'Lokale gegevens',
        more: 'Meer',
        popular_destination: 'Land/regio',
        buy_now: 'Nu kopen',
        package_useing: 'Actief',
        unused: 'Inactief',
        download_app: 'Download APP',
        enter_the_mall_list: 'Ga naar de winkelcentrumlijst',
        no_data: 'Geen gegevens',
        no_data_available: "Geen gegevens beschikbaar",
        copy_success: 'Succesvol gekopieerd',
        copy_fail: 'Kopieer mislukt',
        meritsTitle: 'Wat zijn de voordelen?',
        merits1: 'Geen SIM nodig & Geen maandelijkse kosten',
        merits2: 'Geïntegreerd met de top 2-3 operators voor automatisch netwerkwisseling',
        go_buy: 'Ga kopen',
        instant_savings: 'Bespaar',
        expires_in: 'Vervalt over',
        download_app_tips: "Download de app voor meer aanbiedingen & ervaringen"
      },
      packages: {
        sub_title: {
          us: 'Exclusief Guam, Saipan',
          it: 'Inclusief Vaticaanstad, San Marino',
          va: 'Inclusief Italië, San Marino',
          sm: 'Inclusief Italië, Vaticaanstad',
          ma: 'Inclusief westerse Sahara',
          eh: 'Inclusief Marokko',
          ch: 'Inclusief Liechtenstein',
          li: 'Inclusief Zwitserland',
          fr: 'Inclusief Monaco',
          mc: 'Inclusief Frankrijk',
          fi: 'Inclusief Aland Islands',
          ax: 'Inclusief Finland',
          gu: 'Inclusief noordelijke Mariana -eilanden',
          mp: 'Inclusief Guam'
        },
        unlimited_packages: 'Onbeperkt gegevenspakket',
        normal_packages: 'Normaal gegevenspakket',
        multi_region_packages: 'Multi-regio',
        regional_data: 'Regionale gegevens',
        high_speed_text: 'Hoge snelheidsgegevens',
        infiniteFlow:'Onbeperkte gegevens',
        unLimitData: 'Onbeperkt',
        high_speed_text_year: 'Hoge snelheid/MP',
        package_list: 'Pakketlijst',
        special_offer: 'Sale',
        first_month: '1e Maand',
        periodUnit: {
          day: 'Dag (en)',
          month: 'maand',
          hour: 'uur (en)',
          year: 'jaar',
        },
        periodUnits: {
          day: 'Dag (en)',
          month: 'maanden',
          hour: 'uur (en)',
          year: 'jaar',
        },
        periodUnitSimp: {
          day: 'D',
          month: 'mo',
          hour: 'H',
          year: 'jr'
        },
        periodUnitMonthly:'Maandelijks',
        periodUnitsSimp: {
          day: 'D',
          month: 'mo',
          hour: 'H',
          year: 'jr'
        },
        unlimited_good_name: {
          day: 'Dagpas',
          month: 'Maandelijkse pas',
          year: 'Jaarlijkse pas'
        },
        continuousMonth : "Doorlopende maanden",
        continuousDay : "Doorlopende dagen",
        continuousYear:"Continue jaren",
        
        day_invalid: 'Vervallen op de huidige dag',
        month_invalid: 'Verloop in de huidige maand',
        immediate_valid: 'Onmiddellijk van kracht',
        tomorrow_day_valid: 'Effectief vanaf de volgende dag',
        tomorrow_month_valid: 'Effectief vanaf volgende maand',
    
        // detail page
        detail: {
          cell_flow: 'Gegevens',
          cell_period: 'Geldigheid',
          buy_quantity: 'Hoeveelheid',
          use_area: 'Dekking',
          use_intro: 'Algemene voorwaarden',
          buy_btn: 'Volgorde',
          pay: 'Betalen',
          buy_tips: 'U heeft het %@packageName-pakket in gebruik. Wilt u dit pakket kopen?',
          haveOrderTips: "Niet-betaalde bestelling gegenereerd. Klik Bevestigen om naar mijn datapagina te gaan！"
        },
    
        // confirm page
        confirm: {
          title: 'Bestelbevestiging',
          real_pay_amount: 'Betaald bedrag',
          online_payment: 'Online betaling',
          create_order_error: 'Instelling is mislukt'
        }
      },
      pay: {
        // result page
        result: {
          loading_order_status: 'Bestelstatus krijgen ...',
          buy_success: 'Bestel compleet',
          buy_pending: 'In afwachting van bevestiging',
          buy_pending_tip: 'Betaling in proces ... Als de betaling niet binnen 10 minuten is overgedragen, neem dan contact met ons op voor ondersteuning.',
          get_payment_info_fail: 'Betalingsinformatie -acquisitie is mislukt',
          cell_package: 'Pakket',
          cell_buy_amount: 'Subtotaal',
          cell_real_amount: 'Betaald bedrag',
          go_to_order_btn: 'Ga naar mijn pakket',
          back_home: 'Terug naar huis',
          back_mall: 'Terug naar winkelcentrum',
          ordersn_empty: 'Bestel SN kan niet leeg zijn',
          order_search_error: 'Onverwachte fout',
          goodsName: 'Productnaam'
        },
    
        //fail page
        fail: {
          payment_fail: 'Betaling mislukt',
          //payment_fail_desc: '请返回商品页面，重新购买',
          back_home: 'Terug naar huis'
        }
      },
      CountryGroup: {
        title: "Land/regio",
        placeholder: "Zoek land of regio",
        clear: "Duidelijk",
        history: "Zoekgeschiedenis"
      },
      PromotionCode: {
        verification: {
          title: 'Voucher code',
          minititle:'Voucher code',
          input: 'Voer de bijvoegingscode in',
          explain: 'Tips: raak de scanknop rechtsboven om de QR -code van de voucher -kaart te scannen of voer de voucher -code (case -gevoelig) handmatig in als deze niet werkt.',
          submit: 'Indienen',
          exchange: 'Redeem',
          cancel: 'Annuleren',
          Inquiry: "Wilt u zeker uitwisselen?",
          ErrorCode: 'Laad de codefout op',
        },
        recharge_success: {
          package: 'Pakket',
          content: 'Succesvol ingewisseld',
          back: 'Terug naar winkelcentrum',
          view_packets: 'Ga naar mijn pakket'
        }
      },
      order: {
        state: {
          inUse: 'Geactiveerd',
          isFirst: 'Prioriteit',
          toFirst: 'Stel prioriteit in',
          inactive: 'Geïnactiveerd'
        },
        periodUnits: {
          minute: 'notulen)',
          hour: 'uur (en)',
          day: 'Dag (en)',
          month: 'maanden',
        },
        useIntro: {
          tip1: 'Onbeperkt datapakket heeft een hogere prioriteit dan het gegevenspakket van volume;',
          tip2: 'De gebruiksprioriteit zal zijn gebaseerd op de aankoopdatum voor hetzelfde type pakket, d.w.z. het pakket met de vroegste aankoopdatum zal eerst worden opgebruikt, terwijl de prioriteit van single-region pakketten hoger is dan het regionale pakket;',
          tip3: 'U kunt ook de prioriteit van het gebruik van pakketten van hetzelfde type handmatig aanpassen.'
        },
        myFlow: 'Mijn gegevens',
        remainingFlow: 'Gegevens links',
        remainingTime: 'Geldig links',
        remainingHighFlow: 'Snelle gegevens links',
        validPeriod: 'Geldigheid',
        noneFlow: 'Geen gegevenspakket',
        noneFlowTip: 'Koop het gegevenspakket en geniet van het netwerk van hoge kwaliteit',
        buyPackFlow: 'Pakketten kopen',
        checkInvalidFlow: 'Controleer het verlopen gegevenspakket',
        orderList: {
          "title": "mijn bestellingen",
          "amount_paid": "Totaal",
          "device": "Eigen apparaat",
          "order_details": "Bestelgegevens",
          "total_amont": "Subtotaal",
          "orderSN": "Bestelnr.",
          "createTime": "Creatie tijd",
          "cancelTime": "Gesloten tijd",
          "payTime": "Besteltijd",
          "unsubTime": "Geannuleerde tijd",
          "payMethod": "Betaalmethode",
          "thirdSN": "Transactienr.",
          "delete": "Verwijderen",
          "cancel": "Bestelling annuleren",
          "unsub": "Terugbetaling",
          "goto_cancel": "Wilt u de bestelling annuleren?",
          "goto_unsubscribe": "Wilt u de bestelling afmelden?",
          "delete_Tips": "De bestelling kan niet worden hervat nadat deze is verwijderd, daarom kunnen uw after-serviceproblemen niet worden afgehandeld.Weet je zeker dat je het wilt verwijderen?",
          "status_success": "Voltooid",
          "status_pending": "Onbetaald",
          "status_cancel": "Gesloten",
          "status_unsub": "Geannuleerd",
          "payMethod_stripe": "Creditcard"
        },
      },
      registerlogin: { 
        create_account_tip:"Maak een account aan, begin exclusieve ervaring",
        select_country_tip:"Apparaat Gebruik land/regio",
        email_name: "Mail",
        phone_name: "Telefoon",
        email_address: "E -mailadres",
        password: "wachtwoord",
        country: "land",
        select_country: "Kies een land",
        cancel: "Annuleren",
        confirm: "Zeker",
        please_enter: "Voer 6-20 tekens in (combinatie van letters, nummers of symbolen)",
        select_country_tips: "Landelectie is voor het bekijken van lokale pakketten.Het kan niet worden gewijzigd na registratie.Bevestig alstublieft!",
        global_roaming: "Internationale domeincode",
        phone_number: "telefoonnummer",
        agree: "mee eens zijn",
        user_agreement: "Gebruikersovereenkomst",
        and: "En",
        privacy_policy: "Privacybeleid",
        register_login: "Meld u aan of log in",
        login_error: "Het aantal aanmeldingen is te frequent, probeer het later opnieuw!",
        register_error: "Het aantal registraties is te frequent, probeer het later opnieuw!",
        forgot_pwd: "Vergeet het wachtwoord",
        app_tips: "Log in op de app met dit account na het downloaden om toegang te krijgen tot meer functies.",
        download_app: "Ga naar de app downloaden",
        rememberPwd: "Onthoud het wachtwoord",
        third_login: "Doorgaan met",
        agreement_tips: "Controleer de gebruikerovereenkomst en het privacybeleidsvakje",
        selectCountry_tips: "Houd er rekening mee dat het geregistreerde land rechtstreeks van invloed is op de volgende betaalmethoden en valuta's, selecteer volgens uw behoefte.",
        login_error_cancel: "Gebruiker heeft de aanmelding geannuleerd",
        login_error_auth: "Sta pop-ups toe in de browsersettings",
        device_tips: "Apparaat wacht op activering. Verwerking binnen 24 uur."
      },
      forgotPwd: {
        forgot_pwd: "Vergeet het wachtwoord",
        email_address: "E -mailadres",
        next: "Volgende",
        email_has_been_sent: "We hebben een e -mail gestuurd naar %@email.Klik op de link en volg de stappen om uw wachtwoord op te halen.",
        have_retrieved_it: "Ik heb het gevonden",
        unable_to_receive_email: "Kunt u de e -mail niet ontvangen?Controleer of er e -mails zijn van %@email onder uw spam en verwijderde e -maildirectory",
        or: "of",
        resend: "Weren",
        global_roaming: "Internationale domeincode",
        phone_number: "telefoonnummer",
        verification_code_has_been_sent: "We hebben de verificatiecode gestuurd naar:",
        verification_code: "Verificatiecode",
        no_verification_code_received: "De verificatiecode niet ontvangen?",
        please_enter: "Voer 6-20 tekens in (combinatie van letters, nummers of symbolen)",
        reset_password: "Wachtwoord opnieuw instellen",
        reset_successful: "Succesvol gereset"
      },
      coupons: {
        coupons_name: "Coupons",
        no_coupons: "Nog geen coupons",
        no_data: "Nog geen gegevens",
        applicable_to_the_following: "Coupons zijn geschikt voor het volgende gegevenspakket"
      },
      digital: {
        title: "Apparaat SN",
        purchased: "Mijn aankopen",
        viewAll: "Meer",
        skinStore: "Productwinkel",
        completed: "Gekocht",
        goBuy: "Kopen",
        order: {
            title: "Gekochte bestellingen"
        },
        detail: {
            describe: "Beschrijving"
        }
      },
      viewPL: {
        other: 'ander'
      },
      invalidFlow: {
        stateName: "Status",
        state: {
          NOT_ACTIVATED: "Geïnactiveerd",
          IN_USING: "Beschikbaar",
          USE_END: "Uitgeput",
          EXPIRE: "Verlopen",
          TRANSFER: "Overdracht",
          UNSUBSCRIBE: "Annuleren",
          VALID: "Geldig",
          INVALID: "Ongeldig",
          EXCHANGE_POINTS: "Punten inwisselen"
        },
        noneFlow: "Geen verlopen datapakket",
        pageName: "Verlopen gegevenspakket"
      },
      flowDetail: {
        title: "Gegevensgegevens",
        flow: "Gegevens",
        validTime: "Geldige starts",
        invalidTime: "Geldig tot",
        coverage: "Dekking",
        useIntro: "Algemene voorwaarden",
        purchaseTime: "Gekocht op",
        subtotal: "Subtotaal",
        status: "Status",
        cancel: "Annuleren",
        buyAgain: "Koop het opnieuw",
        validity: "Geldigheid",
        tip: "Kennisgeving",
        cancelTip: "Weet u zeker dat u dit pakket wilt terugbetalen?",
        dataLeft: "Gegevens links"
      },
      netError: {
        try_again: "Probeer het opnieuw",
        net_error: "Geen netwerk",
        try_again_desc: "Controleer de netwerkinstelling en probeer het opnieuw"
      },
      loadFail: {
        try_again: "Probeer het opnieuw",
        load_fail: "Laden is mislukt",
        load_fail_desc: "Gegevensladen is mislukt, probeer het opnieuw",
        IMEI_Not_Exist: "Ik bestaat niet, probeer alsjeblieft vanuit de juiste ingang binnen te komen",
        Project_Not_Exist: "Er treedt een fout op.Neem contact op met de klantenservice. (01)",
        commonError: "Er treedt een fout op.Neem contact op met de klantenservice."
      },
      settlement_Easy_and_convenient: "Gemakkelijk en handig",
      settlement_Great_deal: "Grote deal",
      settlement_Safe_and_secure: "Veilig en veilig",
      settlement_Autopay_service_regulation: "Regelgeving voor automatische incasso",
      settlement_Read: "Lezen",
      settlement_No_coupon: "Geen coupon beschikbaar",
      settlement_Subtotal: "Subtotaal",
      settlement_Coupon: "Coupon",
      settlement_TOTAL: "Totaal",
      settlement_promotion_tip: "Het promotionele aanbod kan niet worden gebruikt in combinatie met coupons",
      settlement_coupon_tip: "De coupon kan niet worden gebruikt in combinatie met andere promotionele aanbiedingen",
      member_myFlow_noList: "Geen gegevens",
      detail_se_content: "Een veilige, gemakkelijke en handige manier.U kunt zich op elk gewenst moment afmelden",
      Enter_Promo_code: "Promotiecode",
      Enter_Promo_Coupon: "Coupons",
      settlement_Not_used_coupon: "Coupon niet gebruikt",
      settlement_Available_coupon: "Beschikbaar",
      settlement_Unavailable_coupon: "Niet beschikbaar",
      please_Enter_Promo_code: "Voer de promotiecode in",
      please_Select_Coupon_use: "Selecteer de coupon die u wilt gebruiken.",
      Buy_Now: "Nu kopen",
      Dont_Use_Any: "Gebruik geen",
      settlement_confirm: "Bevestigen",
    //   "settlement_tips": "确定",
      flowDetail_unsubscribe: "Uitschrijven",
      flowDetail_unsubscribed: "Mescriberen",
      flowDetail_isCancelPackage: "Dit pakket afmelden?",
      flowDetail_confirmAgreementUnsubscribe: "Je kunt niet veel hebben na het afmelden.Weet u zeker dat u zich wilt afmelden?",
      flowDetail_cancel: "Annuleren",
      flowDetail_cancelSuccess: "Succesvol afmelden",
      packages_detail_promotion: "Bevordering",
      orderTips:{
        "iDay" : "dag",
        "iDays" : "dagen",
        "iMonth" : "maand",
        "iMonths" : "maanden",
        'First_charge_discount':"<label class='anyTime_Buy'>%@firstMoney</label>/%@periodSymbol Bij uw eerste koop, betaal %@money/%@periodSymbol later, U kunt zich op elk gewenst moment afmelden",
        'Monthly_discount':"Bespaar %@saveMoney elke %@period! U kunt zich op elk gewenst moment afmelden",
        'Ordinary_monthly_package':"Een veilige, gemakkelijke en handige manier.U kunt zich op elk gewenst moment afmelden",
        "AlreadyPurchased":'Sorry dat u zich op dit moment slechts op één datapakket kunt abonneren.Meld u af van “%@” en abonneer u later op elk gewenste pakket nadat het is verstreken.',
        "Contract_recommendation_First":'<label>Met autopay -service, bij uw eerste koop, betaal alleen</label>'
        +'<p class="money">%@firstMoney</p>'
        +'<p class="SubscribeTips">U kunt zich op elk gewenst moment afmelden'
        +'<a class="btn">Abonneren ></a></p>',
        "Contract_recommendation_Monthly_discount":"<label>Met autopay -service, betaal alleen</label>"
        +'<p class="money">%@money</p>'
        +'<p class="SubscribeTips">U kunt zich op elk gewenst moment afmelden'
        +'<a class="btn">Abonneren ></a></p>',
        "Contract_recommendation_General":"<label>Met autopay -service</label>"
        +'<p class="money">%@money</p>'
        +'<p class="SubscribeTips">Een veilige, gemakkelijke en handige manier.U kunt zich op elk gewenst moment afmelden'
        +'<a href="javascript:;" class="btn">Abonneren ></a></p>',
        'BanlanceDoubleCheck':'Weet u zeker dat u met saldo wilt betalen?',
    },
    feedback: {
      title: "feedback",
      placeholder: "Betreed het land dat u wilt bezoeken of andere vragen, en we zullen zo snel mogelijk aan uw behoeften voldoen!",
      submit: "Indienen",
      submit_success: "Succesvol ingediend",
      other_opinions: "Andere meningen"
    },
    view_country_input: 'Voer uw account in',
    select_package: {
      title: "Data Selecteren",
      allPackage: 'Alle Gegevens',
      type: "Type",
      flow: "Gegevens",
      month_package: "Maandabonnement",
      flow_package: "Datapakket",
      time: "Duur",
      period: "Cykel",
      auto_debit: "Auto-Afschrijving Info",
      auto_subscribe: "Auto-Verlenging",
      detail: "Gegevens Details",
      carrier: "Ondersteunde Operateurs",
      country: "Gedekte Länder",
      notice: "Aankoopgids"
    }
}